"use strict";
import("./main.bootstrap").then((m) => m.mount());
